
import { Component, Vue } from "vue-property-decorator";

@Component({
  inheritAttrs: false,
})
export default class Empty extends Vue {
  test: any = {
    productVersion: "1.0",
    dogId: "4024036655",
    "LCSZR-SWAQ": "1",
    orgName: "山东第一医科大学",
    bindNetwork: false,
    onTrial: false,
    deadline: "2029-03-08 00:00:00",
    productName: "生物安全综合智能演训虚拟仿真平台",
   };
}
